// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/density-altitude.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/density-altitude/density-altitude.js';

mount([g0]);
